export default __webpack_public_path__ + "static/media/logo_edge.52249df8.png";